import { render, staticRenderFns } from "./ordersDone.vue?vue&type=template&id=637dbc3c"
import script from "./ordersDone.vue?vue&type=script&lang=js"
export * from "./ordersDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports